import { Injectable } from "@angular/core";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class SweetAlertService {
  steps = [];

  constructor() {}

  sweetAlertBasic(message) {
    Swal.fire({
      html: message,
      icon: "info",
    });
  }

  sweetAlertSuccess(message) {
    Swal.fire({
      html: message,
      icon: "success",
      focusCancel: true,
    });
  }

  sweetAlertLoading() {
    Swal.fire({
      html: "<strong>Cargando</strong>",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  sweetAlertBasicReturn(message) {
    return {
      html: message,
      icon: "info",
      confirmButtonText: 'Aceptar',
      allowEscapeKey: false,
      allowOutsideClick: false,
    };
  }

  sweetAlertSuccessReturn(message) {
    return {
      html: message,
      icon: "success",
      focusCancel: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
    };
  }

  sweetAlertLoadingReturn() {
    return {
      html: "<strong>Cargando</strong>",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    };
  }

  sweetAlertInsertQueue(swal): void {
    Swal.insertQueueStep(swal);
  }

  addStepsQueue(swal): void {
    this.steps.push(swal);
  }

  anyStepsQueue(): boolean {
    if (this.steps.length == 0) {
      return false;
    } else {
      return true;
    }
  }

  showSwalQueue() {
    Swal.queue(this.steps);
  }
  resetStepsQueue() {
    this.steps = [];
  }
  sweetAlertClose() {
    Swal.close();
  }
}
